import React, { useEffect, useRef, useState } from "react";
import "./Accordian.scss";
import { FaAngleDown } from "react-icons/fa6";

const Accordian = ({ name, initial, children, id }) => {
  const [open, setOpen] = useState(initial || false);

  return (
    <div className={`custom-accordian ${open ? "active" : ""}`}>
      <div
        className={`title ${open ? "active" : ""}`}
        onClick={() => {
          setOpen((pre) => !pre);
        }}
        id={id ? id : ""}
      >
        <p>{name}</p> <FaAngleDown />
      </div>
      <div className="content">{children}</div>
    </div>
  );
};

export default Accordian;
